import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=25f3744b&scoped=true&"
import script from "./AuditLogs.vue?vue&type=script&lang=ts&"
export * from "./AuditLogs.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=25f3744b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3744b",
  null
  
)

export default component.exports